
import { PasswordContent } from "../../components/auth";

export default function Password() {

  return (
    <>
      <PasswordContent/>
    </>
  )

}
